export default {
  'order.title': '订单',

  'order.column.order_number': '订单号',
  'order.column.cart_number': '小票号',
  'order.column.service_type': '服务类型',
  'order.column.order_source': '订单来源',
  'order.column.table_number': '桌号',
  'order.column.guest_quantity': '客人数量',
  'order.column.platform': '下单平台',
  'order.column.status': '订单状态',
  'order.column.employee_name': '服务员',
  'order.column.address': '地址',
  'order.column.driver_name': '司机',
  'order.column.created_at': '下单时间',
  'order.column.closed_at': '关单时间',
  'order.column.base_price': '订单合计',
  'order.column.tips': '服务小费',
  'order.column.driver_tips': '递送小费',
  'order.column.tax': '税',
  'order.column.fee_amount': '费用',
  'order.column.discounts': '折扣',
  'order.column.total': '订单总额',
  'order.column.paid_total': '支付总额',
  'order.column.paid_total.tooltip': '订单支付金额总计。',
  'order.column.refund_total': '退款总额',
  'order.column.refund_total.tooltip': '该订单对应的退款单的加总。',
  'order.column.transaction_id': '交易号',
  'order.column.transaction_method': '交易方式',
  'order.column.operation': '操作',
  'order.column.planned_completion_in': '预计完成时间',

  'order.action.addTips': '加小费',
  'order.action.refund': '退款',
  'order.action.markAsComplete': '标记为完成',

  'order.filter.search': '关键字搜索',
  'order.filter.dateRange': '按时间段查询',
  'order.filter.serviceType': '订单类型',
  'order.filter.orderSource': '订单来源',
  'order.filter.employee': '员工',
  'order.filter.status': '订单状态',
  'order.filterOptionNone': '不限',

  'order.search.placeholder': '订单号',
  'order.search.placeholder1': '订单号 | 小票号',
  'order.status.placeholder': '单选',
  'order.placeholder.multiple': '可多选',

  'order.action.clear': '清空',
  'order.action.default': '设为默认',
  'order.action.applyFilter': '显示筛选',
  'order.action.hide': '隐藏',
  'order.action.clearAll': '清空所有',
  'order.action.confirmDeletion': '确认删除订单',

  'order.period.start': '不早于 {time}',
  'order.period.end': '不晚于 {time}',

  'order.selection.copy': '已选{count}个订单',
  'order.deletion.title': '确认要删除选中的{count}个订单吗？',
};
